<template>
  <el-card :body-style="{ padding: '0px' }" class="card pos-r">
    <el-button type="info" class="btn__image-zoom" size="mini" @click="onClickZoom(item)">
      <i class="material-icons">zoom_in</i>
    </el-button>

    <!-- Image -->
    <slot name="image">
      <div class="card__bg-image" :style="{ 'background-image': 'url(' + item.previews[0] + ')' }"></div>
    </slot>

    <!-- Headline -->
    <h3 class="p-1 m-0 bg-color-lighter-gray">
      <slot name="headline">{{ item.title }}</slot>
    </h3>

    <!-- Default -->
    <div class="card__content">
      <slot></slot>
    </div>

    <!-- Footer -->
    <footer class="card__footer card__footer--border text-right">
      <slot name="footer"></slot>
    </footer>
  </el-card>
</template>

<script>
export default {
  name: 'Card',

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  methods: {
    onClickZoom(item) {
      let { previews } = item;

      if (Array.isArray(previews)) {
        previews = previews[0];
      }

      let content = `<p>Bild konnte nicht geladen werden.`;
      if (previews) {
        content = `<figure class="text-center"><img src="${previews}" /></figure>`;
      }

      this.$store.commit('dialog/OPEN', {
        title: `${item.title}`,
        content
      });
    }
  }
};
</script>

<style scoped lang="scss">
.card {
  &:hover {
    .btn__image-zoom {
      opacity: 1;
    }
  }
}
</style>
